// extracted by mini-css-extract-plugin
export default {"container":"Tgzuh","form":"ljpUh","submitButton":"YlrxM"};